var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px 30px"}},[_c('flow-instance',{attrs:{"request":_vm.request,"design-form-url":_vm.designFormUrl,"base-url":_vm.baseUrl,"token":_vm.token,"page-size":_vm.pageSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }